import { render, staticRenderFns } from "./ParticipantsProducts.vue?vue&type=template&id=2dd1a164&scoped=true"
import script from "./ParticipantsProducts.vue?vue&type=script&lang=js"
export * from "./ParticipantsProducts.vue?vue&type=script&lang=js"
import style0 from "./ParticipantsProducts.vue?vue&type=style&index=0&id=2dd1a164&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd1a164",
  null
  
)

export default component.exports